import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { FirebaseService } from './firebase.service';
import { take } from "rxjs/operators";
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Events } from './events.service';
import { Storage } from '@ionic/storage';
import { AlertController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private snapshotChangesSubscription: any;
  isLoggedIn = false;
  user;
  impersonate: any = null;

  constructor(
    private firebaseService: FirebaseService,
    private events: Events,
    public afs: AngularFirestore,
    public storage: Storage,
    public alertCtrl: AlertController,
    public afAuth: AngularFireAuth
  ) { }

  setLoggedIn(_value) {
    this.isLoggedIn = _value;
  }

  getUser(impersonate = true) {
    if(this.impersonate && impersonate){
      return this.impersonate;
    }
    return this.user;
  }

  setUser(user) {
    return new Promise<any>((resolve, reject) => {
      if (user != null) {
        console.log("set user", user.uid);
        let snapshotChangesRef = this.afs.collection('users').doc(user.uid)
        snapshotChangesRef.valueChanges()
          .pipe(take(1))
          .subscribe(data => {
            console.log("data", data);
            if (data == null || data['uid'] != user.uid) {
              this.presentAlert("Une erreur est survenue", "Nous avons besoin de plus d\'informations, merci de nous contacter (earthency@gmail.com) en nous transmettant votre identifant : " + user.email);
            }
            else if (data["status"] >= 2) {
              this.user = data;

              this.events.publish('user', {});
              resolve(data["status"])

            }
            else {
              this.user = null;
              resolve(data["status"])
            }
          }, err => {
            console.log("setUser error", err);
            this.user = null;
            resolve(this.user)
          })
      }
      else {
        this.user = null;
        resolve(this.user)
      }
    });
  }


  async presentAlert(title, message) {
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }

  async getCredentials() {
    return await this.storage.get('credentials');
  }
  async setCredentials(value) {
    await this.storage.set('credentials', { email: value.email, password: value.password });
  }
  async deleteCredentials() {
    await this.storage.remove('credentials');
  }

  isAnonymous(): boolean {
    console.log("isAnonymous", this.user);
    return this.user && this.user.isAnonymous ? true : false;
  }

  isAuthenticated(): boolean {
    return this.isLoggedIn;
  }

  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.createUserWithEmailAndPassword(value.email, value.password)
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }

  doLogin(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.signInWithEmailAndPassword(value.email, value.password)
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }
  doLoginAnonymous() {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.signInAnonymously()
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }

  doNewPassword(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.sendPasswordResetEmail(value.email)
        .then(
          res => resolve(res),
          err => reject(err))
    })
  }

  doLogout() {
    return new Promise(async (resolve, reject) => {
      await this.deleteCredentials();
      this.afAuth.signOut()
        .then(() => {
          this.setLoggedIn(false);
          this.unsubscribeOnLogOut();
          return resolve(null);
        }).catch((error) => {
          console.error(error);
          reject();
        });
    })
  }
  unsubscribeOnLogOut() {
    //remember to unsubscribe from the snapshotChanges
    console.log("this.snapshotChangesSubscription", this.snapshotChangesSubscription);
    if (this.snapshotChangesSubscription != null)
      this.snapshotChangesSubscription.unsubscribe();
  }
}
